var _style, _defs, _defs2, _defs3, _defs4, _defs5, _rect, _defs6, _defs7, _defs8, _defs9, _defs10, _rect2, _defs11, _defs12, _defs13, _defs14, _defs15, _rect3, _defs16, _defs17, _defs18, _defs19, _defs20, _rect4, _defs21, _defs22, _defs23, _defs24, _defs25, _rect5, _defs26, _defs27, _defs28, _defs29, _defs30, _rect6, _defs31, _defs32, _defs33, _defs34, _defs35, _rect7, _defs36, _defs37, _defs38, _defs39, _defs40, _rect8, _defs41, _defs42, _defs43, _defs44, _defs45, _rect9, _defs46, _defs47, _defs48, _defs49, _defs50, _rect10, _defs51, _defs52, _rect11, _defs53, _defs54, _rect12, _defs55, _defs56, _defs57, _defs58, _defs59, _rect13, _defs60, _defs61, _rect14, _defs62, _defs63, _rect15, _defs64, _defs65, _rect16, _defs66, _defs67, _rect17, _defs68, _defs69, _rect18, _defs70, _defs71, _rect19, _defs72, _defs73, _rect20, _defs74, _defs75, _rect21, _defs76, _defs77, _rect22, _defs78, _defs79, _rect23, _defs80, _defs81, _rect24, _defs82, _defs83, _rect25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgWidgetNoDocumenti(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 383.4 233.9",
    style: {
      enableBackground: "new 0 0 383.4 233.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{clip-path:url(#SVGID_4_);enable-background:new    ;}\n\t.st2{clip-path:url(#SVGID_6_);}\n\t.st3{clip-path:url(#SVGID_8_);}\n\t.st4{clip-path:url(#SVGID_10_);fill:#F2F2F2;}\n\t.st5{clip-path:url(#SVGID_12_);}\n\t.st6{clip-path:url(#SVGID_14_);enable-background:new    ;}\n\t.st7{clip-path:url(#SVGID_16_);}\n\t.st8{clip-path:url(#SVGID_18_);}\n\t.st9{clip-path:url(#SVGID_20_);fill:#C1DEE2;}\n\t.st10{clip-path:url(#SVGID_22_);}\n\t.st11{clip-path:url(#SVGID_24_);enable-background:new    ;}\n\t.st12{clip-path:url(#SVGID_26_);}\n\t.st13{clip-path:url(#SVGID_28_);}\n\t.st14{clip-path:url(#SVGID_30_);fill:#69A1AC;}\n\t.st15{clip-path:url(#SVGID_32_);}\n\t.st16{clip-path:url(#SVGID_34_);enable-background:new    ;}\n\t.st17{clip-path:url(#SVGID_36_);}\n\t.st18{clip-path:url(#SVGID_38_);}\n\t.st19{clip-path:url(#SVGID_40_);fill:#C1DEE2;}\n\t.st20{clip-path:url(#SVGID_42_);}\n\t.st21{clip-path:url(#SVGID_44_);enable-background:new    ;}\n\t.st22{clip-path:url(#SVGID_46_);}\n\t.st23{clip-path:url(#SVGID_48_);}\n\t.st24{clip-path:url(#SVGID_50_);fill:#69A1AC;}\n\t.st25{clip-path:url(#SVGID_52_);}\n\t.st26{clip-path:url(#SVGID_54_);enable-background:new    ;}\n\t.st27{clip-path:url(#SVGID_56_);}\n\t.st28{clip-path:url(#SVGID_58_);}\n\t.st29{clip-path:url(#SVGID_60_);fill:#8AC5CC;}\n\t.st30{clip-path:url(#SVGID_62_);}\n\t.st31{clip-path:url(#SVGID_64_);enable-background:new    ;}\n\t.st32{clip-path:url(#SVGID_66_);}\n\t.st33{clip-path:url(#SVGID_68_);}\n\t.st34{clip-path:url(#SVGID_70_);fill:#8AC5CC;}\n\t.st35{clip-path:url(#SVGID_72_);}\n\t.st36{clip-path:url(#SVGID_74_);enable-background:new    ;}\n\t.st37{clip-path:url(#SVGID_76_);}\n\t.st38{clip-path:url(#SVGID_78_);}\n\t.st39{clip-path:url(#SVGID_80_);fill:#C1DEE2;}\n\t.st40{clip-path:url(#SVGID_82_);}\n\t.st41{clip-path:url(#SVGID_84_);enable-background:new    ;}\n\t.st42{clip-path:url(#SVGID_86_);}\n\t.st43{clip-path:url(#SVGID_88_);}\n\t.st44{clip-path:url(#SVGID_90_);fill:#F2F2F2;}\n\t.st45{clip-path:url(#SVGID_92_);}\n\t.st46{clip-path:url(#SVGID_94_);enable-background:new    ;}\n\t.st47{clip-path:url(#SVGID_96_);}\n\t.st48{clip-path:url(#SVGID_98_);}\n\t.st49{clip-path:url(#SVGID_100_);fill:#F2F2F2;}\n\t.st50{clip-path:url(#SVGID_102_);}\n\t.st51{clip-path:url(#SVGID_104_);fill:#D4A181;}\n\t.st52{clip-path:url(#SVGID_106_);}\n\t.st53{clip-path:url(#SVGID_108_);fill:#222045;}\n\t.st54{clip-path:url(#SVGID_110_);}\n\t.st55{clip-path:url(#SVGID_112_);enable-background:new    ;}\n\t.st56{clip-path:url(#SVGID_114_);}\n\t.st57{clip-path:url(#SVGID_116_);}\n\t.st58{clip-path:url(#SVGID_118_);fill:#222045;}\n\t.st59{clip-path:url(#SVGID_120_);}\n\t.st60{clip-path:url(#SVGID_122_);fill:#C5CFD7;}\n\t.st61{clip-path:url(#SVGID_124_);}\n\t.st62{clip-path:url(#SVGID_126_);fill:#B28B66;}\n\t.st63{clip-path:url(#SVGID_128_);}\n\t.st64{clip-path:url(#SVGID_130_);fill:#222045;}\n\t.st65{clip-path:url(#SVGID_132_);}\n\t.st66{clip-path:url(#SVGID_134_);fill:#925C3C;}\n\t.st67{clip-path:url(#SVGID_136_);}\n\t.st68{clip-path:url(#SVGID_138_);fill:#222045;}\n\t.st69{clip-path:url(#SVGID_140_);}\n\t.st70{clip-path:url(#SVGID_142_);fill:#222045;}\n\t.st71{clip-path:url(#SVGID_144_);}\n\t.st72{clip-path:url(#SVGID_146_);fill:#2E3676;}\n\t.st73{clip-path:url(#SVGID_148_);}\n\t.st74{clip-path:url(#SVGID_150_);fill:#925C3C;}\n\t.st75{clip-path:url(#SVGID_152_);}\n\t.st76{clip-path:url(#SVGID_154_);fill:#4C3E91;}\n\t.st77{clip-path:url(#SVGID_156_);}\n\t.st78{clip-path:url(#SVGID_158_);fill:#DDE3E9;}\n\t.st79{clip-path:url(#SVGID_160_);}\n\t.st80{clip-path:url(#SVGID_162_);fill:#594D9B;}\n\t.st81{clip-path:url(#SVGID_164_);}\n\t.st82{opacity:0.1;clip-path:url(#SVGID_166_);fill:#010202;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M75.8,164.6c104.3,0,302.9,34.8,307.4,54.6c1.2,5.4-4.4,10.3-15.1,14.7l-309.7,0 c-59.1-18-77.3-46.1-36.3-63.1c10.3-4.3,29.1-6.2,52.9-6.2L75.8,164.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -0.5,
    y: -1.1,
    width: 384,
    height: 254
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: -2.5,
    y: 161.9,
    width: 388,
    height: 93
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: -2.1,
    y: 162.5,
    width: 387.6,
    height: 91.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: -0.5,
    y: 163.9,
    width: 384,
    height: 70
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -7.1,
    y: 157.5,
    className: "st4",
    width: 397.6,
    height: 101.7
  })))))))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_11_",
    d: "M276.5,141c0.2-0.5,0.4-1.1,0.5-1.7C276.9,140,276.8,140.6,276.5,141z M224.6,62.4 c0.9,0.5,1.8,1.1,2.4,1.9c0.2,0.3,0.8,2.2,1,2.2c-1.8,0-5.1,0-6-2.1c-0.6-1.5,0.4-2.3,1.5-2.3C223.8,62.2,224.2,62.2,224.6,62.4z  M228.7,58.2c0.6,0.7,0.5,5.8-0.5,6.1c0.3,1.7,0.6,3.4,1,5c0.1,0,0.1,0,0.2,0c0-0.4,0-0.9,0-1c0.1-1.3,1.3-4,3.1-3.5 c1.4,0.4,0.5,2.1,0.1,2.8c-0.8,1.2-1.6,1.7-2.7,2.3c0,0.3-0.2,0.4-0.4,0.4c0.7,2.7,1.7,5.3,2.9,7.8c0.2-0.8,0.4-1.8,0.5-2 c0.6-1,2-2.1,3.2-1.6c2.6,1.2-0.2,4.6-2.4,5c-0.1,0.1-0.2,0.2-0.3,0.3c0.4,0.7,0.9,1.5,1.4,2.2c0.7,1.1,1.5,2.1,2.4,3.2 c0-0.8,0.4-2.7,0.4-2.9c0.6-1.2,2.2-2.4,3.5-1.6c1.5,1,0.1,2.8-0.7,3.6c-0.3,0.3-2.1,1.6-2.7,1.6c2,2.5,4.2,5,6.5,7.3 c-0.2-1.1-0.4-4-0.4-4.3c0.1-1.7,1.2-4.3,3.4-3.7c2.1,0.6,1.2,3.4,0.5,4.7c-0.4,0.8-1,1.6-1.8,2.2c-0.3,0.2-0.8,0.4-1,0.6 c-0.2,0.2-0.1,0.6-0.4,0.8c1.2,1.3,2.5,2.5,3.7,3.7c0.6,0.6,1.2,1.1,1.7,1.7c0.3-0.1,0.8,0,0.8,0.5c0,0.1,0,0.1,0,0.2 c0.4,0.4,0.9,0.8,1.3,1.2c0-0.1,0-0.3,0-0.5c-0.4,0.6-0.3-0.8-0.3-1.1c-0.2-1-0.4-2-0.4-3.1c0-1.5,1-4.1,3-3.2 c1.9,0.8,1.2,3.1,0.5,4.5c-0.4,0.9-1.1,1.7-1.7,2.4c-0.3,0.3-0.6,1-0.9,1.1c2.5,2.2,5.1,4.4,7.7,6.6c0-0.1,0.1-0.3,0.1-0.4 c0,0.1-0.1,0.1-0.2,0.1c-0.3-1.5-2.4-9.5,2-8.1c3,1,0.9,6.8-1.3,8.9c1.3,1.1,2.7,2.3,4,3.5c0.9,0.9,1.9,1.8,2.7,2.7 c-0.5-1.2-0.9-2.8-0.6-4c0.4-1.8,2.3-3.5,4.2-2.5c3.5,1.9-2.4,4.9-3.1,7c2.8,3,5.2,6.4,6.8,10.3c1.7,4.2,3.3,9.8,2.5,14.5 c0.2-2.3-0.7-5.4-1.2-7.1c-0.7-2.8-1.8-5.5-3.2-8.1c-2.2-4.1-5.1-7.6-8.5-10.8c-1.2,0.4-2.7,1.4-3.4,1.7c-1.3,0.6-3.8,1.3-4.6-0.4 c-0.8-1.7,1.3-2.7,2.5-3.1c1.2-0.4,2.4-0.3,3.5,0c-2.1-1.9-4.3-3.7-6.5-5.5c-1.9,1.6-4.7,6.1-7.1,3.7c-2.8-2.7,2.5-5.4,4.8-5.2 c0.3,0,0.5,0.1,0.8,0.2c-2.3-1.9-4.6-3.9-6.7-6c-1.2,0.2-4.9,5.6-7.4,3.3c-1.2-1.2-0.8-3,0.4-4.1c1.2-1.1,2.9-1.1,4.4-0.7 c0.6,0.2,1.2,0.4,1.8,0.8l0.1,0c-2.1-2.1-4.2-4.3-6.3-6.5c0,0-0.1,0-0.1,0c-0.1,0.1-0.3,0.2-0.5,0.2c-1.7,0.6-3.9,1.4-5.6,1.1 c-1.2-0.2-2.3-1.2-1.3-2.4c0.8-1,3-0.8,4.1-0.6c0.7,0.2,1.6,0.7,2.4,1.1c0.1-0.1,0.2-0.2,0.3-0.2c-2-2.2-3.9-4.6-5.7-7 c-1.8,0.3-4.3,2.3-5.9,0.4c-1.7-1.9,1.5-3.1,2.9-2.9c0.5,0.1,1,0.2,1.5,0.4c-1.3-2-2.2-4.1-2.9-6.3c0,0,0,0-0.1,0c0,0,0,0,0,0 c-0.1-0.2-0.1-0.4-0.2-0.7c-0.1-0.1-0.2-0.1-0.3-0.1c0.7,0.5-2.2,0.7-2.7,0.7c-1.2,0.1-2.7,0.1-3.6-0.8c-0.7-0.8-0.7-2,0.2-2.7 c1.1-0.8,2.7-0.3,3.8,0.2c0.4,0.2,1.5,0.8,2.3,1.4c-0.1-0.5-0.2-0.9-0.3-1.4c-0.3-1.9-0.6-3.9-0.7-5.8c0-0.7,0-1.5,0.1-2.2 c0,0-0.1-0.1-0.1-0.2c0,0.2,0,0.2-0.1,0.1c-0.8-1.2-1.5-2.5-1.6-4c-0.1-0.9,0.5-2.5,1.4-2.5C228.1,57.6,228.4,57.8,228.7,58.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_13_",
    x: -0.5,
    y: -1.1,
    width: 384,
    height: 254
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    x: 215.5,
    y: 44.9,
    width: 68,
    height: 89
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_17_",
    x: 207,
    y: 57.5,
    transform: "matrix(5.232266e-02 -0.9986 0.9986 5.232266e-02 147.362 333.6836)",
    width: 84.9,
    height: 63.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_19_",
    x: 220.5,
    y: 56.9,
    width: 58,
    height: 85
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 210.7,
    y: 40.1,
    className: "st9",
    width: 77.7,
    height: 98.1
  })))))))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_21_",
    d: "M314.6,37.1c0.1,0,0.1,0,0.2,0c1.4,0,0.9,5.5,0.9,6.6c0.1,4.4-0.4,8.8-0.9,13.2c-1,7.9-4.1,15-8.4,21.7 c-2.2,3.5-4.8,7-8.4,9.2c-1.7,1-3.7,1.2-5.3,2c-1.9,1-0.9,0.2-1.7,2.2c-1.2,2.8-1.6,6.3-2.1,9.3c-2.5,13.5-8.7,84.9-7.6,98.7 c0.1,1.2-1.6,1.5-1.7,0c-0.5-7.9,3.4-62.5,5.4-80.3c2-17.9,4-33.6,6-39.8c2.4-7.5,6.8-16.5,10.4-23.5c1.7-3.2,3.5-6.4,5.6-9.4 C308.8,44.4,312.1,38,314.6,37.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_23_",
    x: -0.5,
    y: -1.1,
    width: 384,
    height: 254
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_25_",
    x: 276.5,
    y: 34.9,
    width: 42,
    height: 169
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_27_",
    x: 277.4,
    y: 35,
    width: 40.5,
    height: 168.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_29_",
    x: 278.5,
    y: 36.9,
    width: 38,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 272.4,
    y: 30,
    className: "st14",
    width: 50.5,
    height: 178.1
  })))))))), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_31_",
    d: "M320.2,134.5c0.9-0.7,1.8-1,2.7-1c3.5,0,6,4.6,2.7,7.3c-2.3,1.9-4.7,1.2-6.1-0.4c-0.9,1.1-1.7,2.2-2.5,3.1 c-2.4,2.9-4.7,5.8-6.9,8.9c-4.5,6.3-8.4,12.9-12.5,19.5c-4,6.4-8,12.9-11.6,19.5c-3.1,5.6-7.2,12.2-8.2,18.3 c1.6-13,7.7-25.5,14.9-37c7.2-11.4,15.4-23.8,26.5-32.8C318.1,138.5,318,136.1,320.2,134.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_33_",
    x: -0.5,
    y: -1.1,
    width: 384,
    height: 254
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_35_",
    x: 275.5,
    y: 130.9,
    width: 54,
    height: 82
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_36_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_35_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_37_",
    x: 275.7,
    y: 131.5,
    width: 53.5,
    height: 80.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_37_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_39_",
    x: 277.5,
    y: 132.9,
    width: 52,
    height: 77
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_40_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_39_",
    style: {
      overflow: "visible"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 270.7,
    y: 126.5,
    className: "st19",
    width: 63.5,
    height: 90.5
  })))))))), /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_41_",
    d: "M231.9,104.4c0-0.9,0.2-1.6,0.7-1.6c0,0,0.1,0,0.1,0c2.6,0.5,6.8,6.3,8.9,8.6c2.5,2.6,4.8,5.5,7,8.4 c4.7,6.3,8.8,13.1,12.3,20.1c5.8,11.5,10.4,23.3,13.7,35.8c2.1,7.6,3.4,15.6,4.2,23.5c0.1,1.5,1.7,12.9-0.5,13.2 c-2,0.3-1.4-8.7-1.5-9.9c-1.1-13.8-4.4-27.2-9-40.1c-1-2.8-1.9-6.3-3.5-8.8c-1.1-1.8,0-1.2-2-1.9c-1.7-0.6-3.7-0.5-5.5-1.2 c-3.9-1.6-7-4.7-9.7-7.7c-5.3-6-9.4-12.5-11.6-20.2c-1.2-4.3-2.3-8.6-2.9-13C232.5,108.8,231.9,106.2,231.9,104.4L231.9,104.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_42_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_41_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_43_",
    x: -0.5,
    y: -1.1,
    width: 384,
    height: 254
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_44_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_43_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_45_",
    x: 229.5,
    y: 99.9,
    width: 53,
    height: 115
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_46_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_45_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st22"
  }, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_47_",
    x: 229.8,
    y: 100.7,
    width: 51.8,
    height: 113.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_48_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_47_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_49_",
    x: 231.5,
    y: 101.9,
    width: 50,
    height: 111
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_50_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_49_",
    style: {
      overflow: "visible"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 224.8,
    y: 95.7,
    className: "st24",
    width: 61.8,
    height: 123.8
  })))))))), /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_51_",
    d: "M239.3,0.3c0.1-0.1,0.2-0.2,0.3-0.3c1.1,1.9,2.3,3.8,3.4,5.8c9.7,16.8,17.7,35.4,22.9,54.1 c3.1,11.4,5.3,23,7.5,34.6c3.4,17.9,6.5,35.8,7.4,54.1c0.9,18.3,2.7,39.5-3.3,57.1c3-17.9,0.1-37-0.4-55.1 c-0.2-8.6-0.9-17.1-1.9-25.7c-0.9-8.3-2.3-16.6-3.7-24.8c-0.7-4-1.4-8-2.1-12c-0.2-1.2-0.3-4.7-1.1-5.6c-0.8-0.8-4.7-1.2-5.9-1.8 c-2.5-1.2-4.8-2.9-6.8-4.8c-3.9-3.5-7.3-8.1-10-12.6c-6.2-10.4-8.7-23.1-8.6-35.2C237,25.9,240.8,0.7,239.3,0.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_52_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_51_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_53_",
    x: -0.5,
    y: -1.1,
    width: 384,
    height: 254
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_54_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_53_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st26"
  }, /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_55_",
    x: 234.5,
    y: -3.1,
    width: 50,
    height: 211
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_56_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_55_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st27"
  }, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_57_",
    x: 234.9,
    y: -2.1,
    width: 48.9,
    height: 209.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_58_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_57_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st28"
  }, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_59_",
    x: 236.5,
    y: -0.1,
    width: 47,
    height: 206
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_60_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_59_",
    style: {
      overflow: "visible"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 229.9,
    y: -7.1,
    className: "st29",
    width: 58.9,
    height: 219.9
  })))))))), /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_61_",
    d: "M348.4,64.9c0,0,0.1,0,0.1,0c0.2,0,0.1,0.2,0,0.5c-0.2,0.4-0.5,0.8,1,0.1c-1.2,1.1-0.5,2.6-0.5,4.1 c0,2.4-0.4,4.9-0.8,7.3c-0.7,3.8-1.8,7.4-3.4,11c-3.4,7.7-9.2,15-16.1,19.8c-3.4,2.4-6.7,3.2-10.6,4.3c-2.5,0.7-2.6,2-4,4.3 c-2.7,5-5.4,9.9-7.8,15c-2.9,6.1-5.6,12.3-8.2,18.5c-8.8,21-16,42.8-19.8,65.3c-0.1-13.3,3-26.9,6.8-39.6 c2.8-9.2,6.5-18.1,10.4-26.9c0.9-2.1,2.4-4.9,2.8-7.2c0.3-1.6-0.6-3.2-1-5c-1.5-6.8-1.4-14.3-0.1-21.1c1.5-7.5,5.8-11,13.1-12 c2.7-0.4,6.1-0.2,8.5-1.4c2.7-1.2,3.8-5.3,5.3-7.9c4.1-7,8.9-13.8,14.5-19.7c1.5-1.6,3.2-3.1,4.9-4.5c1.1-0.9,3.4-2,4.2-3.1 C347.9,66.3,348.9,64.8,348.4,64.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_62_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_61_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st30"
  }, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_63_",
    x: -0.5,
    y: -1.1,
    width: 384,
    height: 254
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_64_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_63_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st31"
  }, /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_65_",
    x: 275.5,
    y: 61.9,
    width: 77,
    height: 156
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_66_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_65_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st32"
  }, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_67_",
    x: 276.2,
    y: 62.8,
    width: 75.4,
    height: 154.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_68_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_67_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st33"
  }, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_69_",
    x: 277.5,
    y: 63.9,
    width: 72,
    height: 152
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_70_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_69_",
    style: {
      overflow: "visible"
    }
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 271.2,
    y: 57.8,
    className: "st34",
    width: 85.4,
    height: 164.2
  })))))))), /*#__PURE__*/React.createElement("g", null, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_71_",
    d: "M266,200.6h25.9c1.2,0,2.1,0.9,2.1,2.1c0,0.1,0,0.2,0,0.3l-2,13.6c-0.6,4.1-4.2,7.2-8.3,7.2h-9.4 c-4.2,0-7.7-3.1-8.3-7.2l-2-13.6c-0.2-1.2,0.6-2.2,1.8-2.4C265.8,200.6,265.9,200.6,266,200.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_72_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_71_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st35"
  }, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_73_",
    x: -0.5,
    y: -1.1,
    width: 384,
    height: 254
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_74_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_73_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st36"
  }, /*#__PURE__*/React.createElement("g", null, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_75_",
    x: 261.5,
    y: 197.9,
    width: 35,
    height: 28
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_76_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_75_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st37"
  }, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_77_",
    x: 261.8,
    y: 198.5,
    width: 34.3,
    height: 27.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_78_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_77_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st38"
  }, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_79_",
    x: 263.5,
    y: 199.9,
    width: 31,
    height: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_80_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_79_",
    style: {
      overflow: "visible"
    }
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 256.8,
    y: 193.5,
    className: "st39",
    width: 44.3,
    height: 37.4
  })))))))), /*#__PURE__*/React.createElement("g", null, _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_81_",
    d: "M242.6,207.5c0,9,0.7,16.2,10.2,16.2c9.5,0,10.2-7.3,10.2-16.2H242.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_82_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_81_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st40"
  }, _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_83_",
    x: -0.5,
    y: -1.1,
    width: 384,
    height: 254
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_84_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_83_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_85_",
    x: 239.5,
    y: 204.9,
    width: 26,
    height: 21
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_86_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_85_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st42"
  }, _defs44 || (_defs44 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_87_",
    x: 240.5,
    y: 205.4,
    width: 24.6,
    height: 20.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_88_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_87_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, _defs45 || (_defs45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_89_",
    x: 242.5,
    y: 206.9,
    width: 21,
    height: 17
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_90_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_89_",
    style: {
      overflow: "visible"
    }
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 235.5,
    y: 200.4,
    className: "st44",
    width: 34.6,
    height: 30.5
  })))))))), /*#__PURE__*/React.createElement("g", null, _defs46 || (_defs46 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_91_",
    d: "M255.8,221.3c0-0.1,0-0.2-0.1-0.3C255.8,221.1,255.8,221.2,255.8,221.3z M258,187.1 c-2.1,1.1-2.7,4.4-3.4,6.1c-1,2.4-1.8,4.9-2.1,7.5c-0.1,0.6-0.1,1.3-0.1,1.9c-0.1-0.2-0.1-0.3-0.2-0.5c-1.2-2.8-2.8-5.5-4.8-8 c-0.5-0.6-6.7-6.7-7.1-5.8c0,0.1,0.1,0.2,0.3,0.3c0,0,0,0,0,0c0.4,0.6,1.4,1.5,1.7,2c0.8,1.3,1.4,2.7,2.1,4 c1.3,2.8,2.6,5.7,3.8,8.6c0.3,0.7,0.6,1.3,0.9,2c-3.1-4.5-7.2-8.5-12.9-10.8c1.9,1,3.2,2.8,4.5,4.3c1.6,1.7,3.2,3.4,4.8,5.1 c1.9,2,4.1,4.1,5.9,6.4c1.7,3.6,3.4,7.1,4.4,10.9c-0.3-1.3,0-3,0-4.3c-0.1-1.1-0.2-2.2-0.4-3.3c0.2,0.5,0.4,1,0.5,1.4 c-0.1-0.8-0.2-1.5-0.3-2.3c0.2-0.7,0.5-1.4,0.7-1.9c0.8-2.8,1.9-5.6,3.2-8.3c1.3-2.5,2.7-5,4.3-7.4c0.7-1.1,1.5-2.2,2.2-3.3 c0.5-0.7,1-1.9,1.6-2.6c-4.4,4-9.2,8-12,12.9c-0.3,0.6-0.7,1.2-0.9,1.8c0-1.3,0.1-2.6,0.3-3.9c0.3-2.2,0.8-4.5,1.3-6.7 c0.3-1.6,0.3-4.5,1.6-5.8c0.4-0.3,0.4,0.3,0.4,0.5c0,0,0-0.2,0-0.4C258.3,187.3,258.2,187.1,258,187.1 C258.1,187.1,258,187.1,258,187.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_92_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_91_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, _defs47 || (_defs47 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_93_",
    x: -0.5,
    y: -1.1,
    width: 384,
    height: 254
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_94_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_93_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st46"
  }, /*#__PURE__*/React.createElement("g", null, _defs48 || (_defs48 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_95_",
    x: 233.5,
    y: 184.9,
    width: 37,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_96_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_95_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st47"
  }, _defs49 || (_defs49 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_97_",
    x: 234,
    y: 185,
    width: 35.7,
    height: 38.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_98_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_97_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st48"
  }, _defs50 || (_defs50 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_99_",
    x: 235.5,
    y: 186.9,
    width: 33,
    height: 35
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_100_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_99_",
    style: {
      overflow: "visible"
    }
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 229,
    y: 180,
    className: "st49",
    width: 45.7,
    height: 48.4
  })))))))), /*#__PURE__*/React.createElement("g", null, _defs51 || (_defs51 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_101_",
    d: "M109.5,80.5c2.4,4.5,2.1,15.8-1,16.6c-1.2,0.3-3.9-0.5-6.5-2.1l1.7,11.9h-9.9L97.2,91c-1.9-2.2-3.2-5-3-8 C94.8,74.1,107.1,76,109.5,80.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_102_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_101_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, _defs52 || (_defs52 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_103_",
    x: -0.5,
    y: -1.1,
    width: 384,
    height: 254
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_104_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_103_",
    style: {
      overflow: "visible"
    }
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 88.8,
    y: 71.7,
    className: "st51",
    width: 27.4,
    height: 40.2
  })))), /*#__PURE__*/React.createElement("g", null, _defs53 || (_defs53 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_105_",
    d: "M96.4,93c-1.2-5.5-4.8-9.3-4.3-11.8c0.4-1.7,1.3-2.7,2.9-3.1c0.8-3.3,3.4-4.7,7.8-4.2 c6.6,0.7,10.6,3.5,8.9,9.5c-1.6,0-3.5-0.6-6.2,0.4c-0.8,0.3-1.5,1.3-1.8,2.9h-1.2c-1.2-1.9-2.3-2.7-3.5-2.1 c-1.1,0.5-1.4,1.8-0.8,3.8L97.7,93H96.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_106_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_105_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st52"
  }, _defs54 || (_defs54 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_107_",
    x: -0.5,
    y: -1.1,
    width: 384,
    height: 254
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_108_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_107_",
    style: {
      overflow: "visible"
    }
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 87.1,
    y: 68.8,
    className: "st53",
    width: 30.1,
    height: 29.2
  })))), /*#__PURE__*/React.createElement("g", null, _defs55 || (_defs55 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_109_",
    d: "M99.3,76.5c-2,0.6-3.7,1.7-4.5,4c-2.7,4.5-0.7,9.3,2.1,10.9c0.7-0.8,1.4-1.7,2-2.5 c-0.5-0.4-0.8-1.1-0.8-1.7c0-1.3,1.1-2.4,2.5-2.4c0.1,0,0.2,0,0.3,0c0.1,4.7,0.5,7.8,1,9.3c0.8,2.3,5.4,2.9,7,2.9 c1.6,0,1.3-1.7,1.3-2.6c0-0.2-0.3-0.2-0.7-0.2c-0.5,0-1,0-1-0.5c0-0.9,2.1-1.5,2.5-2c0.5-0.7,0.7-1.7-0.1-1.7 c-1.1,0-3.2,1.5-5.6,1.5c-1.6,0-2.6-2.6-3-7.7c0.9-1.2,1.7-2.2,2.8-2.7c4.4,0.1,4.9-0.7,4.9-3.3c-0.7-0.5-3.2-1.3-6-1.5 c-0.6-0.2-1.2-0.2-1.8-0.2C101.3,75.9,100.3,76.1,99.3,76.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_110_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_109_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st54"
  }, _defs56 || (_defs56 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_111_",
    x: -0.5,
    y: -1.1,
    width: 384,
    height: 254
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_112_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_111_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st55"
  }, /*#__PURE__*/React.createElement("g", null, _defs57 || (_defs57 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_113_",
    x: 91.5,
    y: 72.9,
    width: 22,
    height: 26
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_114_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_113_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st56"
  }, _defs58 || (_defs58 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_115_",
    x: 91.5,
    y: 72.9,
    width: 22,
    height: 26
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_116_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_115_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st57"
  }, _defs59 || (_defs59 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_117_",
    x: 91.5,
    y: 75.9,
    width: 21,
    height: 21
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_118_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_117_",
    style: {
      overflow: "visible"
    }
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 86.5,
    y: 67.9,
    className: "st58",
    width: 32,
    height: 36
  })))))))), /*#__PURE__*/React.createElement("g", null, _defs60 || (_defs60 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_119_",
    d: "M104.6,170.2H75c-2.2,0-4,1.8-4,4v20.1c0,2.2,1.8,4,4,4h29.6c2.2,0,4-1.8,4-4v-20.1 C108.6,172,106.9,170.2,104.6,170.2z M104.2,158.6c8.8,0,16,7.2,16,16v19.3c0,8.8-7.2,16-16,16H75.5c-8.8,0-16-7.2-16-16v-19.3 c0-8.8,7.2-16,16-16H104.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_120_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_119_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st59"
  }, _defs61 || (_defs61 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_121_",
    x: -0.5,
    y: -1.1,
    width: 384,
    height: 254
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_122_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_121_",
    style: {
      overflow: "visible"
    }
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 54.5,
    y: 153.6,
    className: "st60",
    width: 70.8,
    height: 61.3
  })))), /*#__PURE__*/React.createElement("g", null, _defs62 || (_defs62 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_123_",
    d: "M161.2,207.8c-8.1-10-13.7-17.3-16.5-22.1c-4.9-8.2-9-15.6-10.2-18.4c-3-6.7,7-9.8,9.3-6.7 c3.4,4.7,10.8,19.5,22,44.5L161.2,207.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_124_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_123_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st61"
  }, _defs63 || (_defs63 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_125_",
    x: -0.5,
    y: -1.1,
    width: 384,
    height: 254
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_126_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_125_",
    style: {
      overflow: "visible"
    }
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 128.9,
    y: 154.4,
    className: "st62",
    width: 41.8,
    height: 58.4
  })))), /*#__PURE__*/React.createElement("g", null, _defs64 || (_defs64 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_127_",
    d: "M144.5,204.9l-15.2-38.2c-3.2-7,12.4-11.5,14.8-8.3c5.4,7.4,18.3,36.4,19.9,38.6L144.5,204.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_128_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_127_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st63"
  }, _defs65 || (_defs65 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_129_",
    x: -0.5,
    y: -1.1,
    width: 384,
    height: 254
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_130_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_129_",
    style: {
      overflow: "visible"
    }
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 123.9,
    y: 152.4,
    className: "st64",
    width: 45.1,
    height: 57.6
  })))), /*#__PURE__*/React.createElement("g", null, _defs66 || (_defs66 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_131_",
    d: "M104.1,197.3c3-4.3,13.7-18.8,19.6-24.8c1.7-1.7,3.3-3.4,4.9-4.9c4.6-4.6,13.8,3.1,9.2,7.3 c-11.5,10.4-28.2,24.4-29.6,25.7C106.2,202.3,102.2,200,104.1,197.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_132_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_131_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st65"
  }, _defs67 || (_defs67 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_133_",
    x: -0.5,
    y: -1.1,
    width: 384,
    height: 254
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_134_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_133_",
    style: {
      overflow: "visible"
    }
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 93.7,
    y: 173.5,
    transform: "matrix(0.6293 -0.7771 0.7771 0.6293 -98.6619 162.8926)",
    className: "st66",
    width: 55.5,
    height: 22.8
  })))), /*#__PURE__*/React.createElement("g", null, _defs68 || (_defs68 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_135_",
    d: "M102,201.3l4.3-6.6l6.9,4c1.9,4.2,5.1,8.4,9.5,12.9l-0.8,1.3l-12.4-7.2l-3.9-3.1l-0.4,0.6L102,201.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_136_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_135_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st67"
  }, _defs69 || (_defs69 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_137_",
    x: -0.5,
    y: -1.1,
    width: 384,
    height: 254
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_138_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_137_",
    style: {
      overflow: "visible"
    }
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 187.1,
    transform: "matrix(0.5 -0.866 0.866 0.5 -119.3337 200.4967)",
    className: "st68",
    width: 17.9,
    height: 33
  })))), /*#__PURE__*/React.createElement("g", null, _defs70 || (_defs70 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_139_",
    d: "M156.6,211.8l0.4-8.4h8.3c3.9,2.8,9,5.1,15.3,6.8v1.6h-15l-5.1-0.8v0.8H156.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_140_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_139_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st69"
  }, _defs71 || (_defs71 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_141_",
    x: -0.5,
    y: -1.1,
    width: 384,
    height: 254
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_142_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_141_",
    style: {
      overflow: "visible"
    }
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 151.6,
    y: 198.4,
    className: "st70",
    width: 34,
    height: 18.4
  })))), /*#__PURE__*/React.createElement("g", null, _defs72 || (_defs72 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_143_",
    d: "M123.9,168.6c-12.6-2.1-21-3.5-25.3-4.2c-12.2-2.2-15.8-8.7-13.7-23.1h22.5c3,0.9,15.4,6.2,37.3,16 c3.9,2,3.2,7.7,2.5,9.6c0,0.1-6.7,11.5-19.9,34.2l-18.4-11.7l15.1-19.3C124.3,169.2,124.3,168.8,123.9,168.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_144_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_143_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st71"
  }, _defs73 || (_defs73 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_145_",
    x: -0.5,
    y: -1.1,
    width: 384,
    height: 254
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_146_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_145_",
    style: {
      overflow: "visible"
    }
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 79.3,
    y: 136.4,
    className: "st72",
    width: 73.4,
    height: 69.7
  })))), /*#__PURE__*/React.createElement("g", null, _defs74 || (_defs74 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_147_",
    d: "M125.5,135.9l13.2,9.7c3.6,1,6.6,2.2,9,3.6c0.6,0.5,1.3,1.6-1.1,1.4c-0.2,0-0.3,0-0.5,0l-0.5,0 c-2-0.1-3.9-0.1-4.2,0.6c-0.3,0.8,1.1,1.8,0.4,2.8c-0.4,0.7-2.5-1.1-6.2-5.4l-13.1-5.4L125.5,135.9z M74.9,136.3l8.6,0 c-5.3,17.2-8.2,26.4-8.6,27.4c-1,2.4,1.1,6,1.9,7.9c-2.8,1.3-2.5-3.4-6.1-1.8c-0.6,0.3-1.1,0.6-1.6,0.9l-0.4,0.2 c-2.4,1.4-4.5,2.7-7.4,0.8c-0.5-0.3-1-1.4,0.3-2.2c3-2.1,7.4-5.7,8-6.9C70.3,161.1,72.1,152.3,74.9,136.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_148_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_147_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st73"
  }, _defs75 || (_defs75 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_149_",
    x: -0.5,
    y: -1.1,
    width: 384,
    height: 254
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_150_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_149_",
    style: {
      overflow: "visible"
    }
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 55.8,
    y: 130.9,
    className: "st74",
    width: 97.4,
    height: 46.8
  })))), /*#__PURE__*/React.createElement("g", null, _defs76 || (_defs76 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_151_",
    d: "M99.4,100l3.6-0.6c13.3,11.5,18.7,33.5,35,45.2l-3.9,4.9C105.8,145.9,98.9,119,99.4,100z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_152_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_151_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st75"
  }, _defs77 || (_defs77 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_153_",
    x: -0.5,
    y: -1.1,
    width: 384,
    height: 254
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_154_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_153_",
    style: {
      overflow: "visible"
    }
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 98.3,
    transform: "matrix(8.715575e-02 -0.9962 0.9962 8.715575e-02 -15.7497 231.6127)",
    className: "st76",
    width: 57.1,
    height: 52.3
  })))), /*#__PURE__*/React.createElement("g", null, _defs78 || (_defs78 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_155_",
    d: "M83.8,145c14.3,0,24.9,0,31.6,0c1.4,0,1.2-2.1,1-3.1c-2.4-12.2-11.8-25.3-11.8-42.6l-9.1-1.4 C87.9,110,85.3,124.9,83.8,145z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_156_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_155_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st77"
  }, _defs79 || (_defs79 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_157_",
    x: -0.5,
    y: -1.1,
    width: 384,
    height: 254
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_158_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_157_",
    style: {
      overflow: "visible"
    }
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 78.8,
    y: 92.8,
    className: "st78",
    width: 42.8,
    height: 57.2
  })))), /*#__PURE__*/React.createElement("g", null, _defs80 || (_defs80 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_159_",
    d: "M94.8,97.8L94.8,97.8l3.7,0.2c8.1,27.5,10.4,46,6.9,55.3l-0.1,0.3l-24.9,0c-1.5,3.4-2.9,6.3-4.2,8.7h-6.8 C68.5,135.6,77,114.1,94.8,97.8l-0.3,0.3l0.2-0.3H94.8L94.8,97.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_160_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_159_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st79"
  }, _defs81 || (_defs81 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_161_",
    x: -0.5,
    y: -1.1,
    width: 384,
    height: 254
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_162_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_161_",
    style: {
      overflow: "visible"
    }
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 64.3,
    y: 92.8,
    className: "st80",
    width: 47.7,
    height: 74.5
  })))), /*#__PURE__*/React.createElement("g", null, _defs82 || (_defs82 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_163_",
    d: "M89.6,153.6l-9.2,0c1.7-4,3.5-8.8,5.4-14.3C86.6,145.9,87.9,150.7,89.6,153.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_164_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_163_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st81"
  }, _defs83 || (_defs83 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_165_",
    x: -0.5,
    y: -1.1,
    width: 384,
    height: 254
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_166_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_165_",
    style: {
      overflow: "visible"
    }
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 75.4,
    y: 134.4,
    className: "st82",
    width: 19.2,
    height: 24.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgWidgetNoDocumenti);
export default __webpack_public_path__ + "static/media/imgWidgetNoDocumenti.7cfd08f4d7418d22191d7ab0fe7464c2.svg";
export { ForwardRef as ReactComponent };